import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import '@/shared/styles/global.css'

const container = document.getElementById('root')
if (!container) throw new Error('#root not found')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

/**
 * Register the service worker, which is what makes the app installable.
 *
 * After load, so it never competes with the first render for bandwidth on the
 * connection where that matters — a phone on hall wifi.
 *
 * Only in a real build. A worker registered against the dev server caches the
 * unbundled modules Vite serves and then keeps serving them after a change,
 * which looks exactly like the app ignoring your edits.
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // An install prompt that does not appear is a missing convenience, not a
      // broken app. Nothing here is worth interrupting anyone over.
    })
  })
}
